export const NAV_LINKS = [
  { label: "Home", target: "home" },
  { label: "Group", target: "group" },
  { label: "Businesses", target: "businesses" },
  { label: "Approach", target: "approach" },
  { label: "Global", target: "global" },
  { label: "Contact", target: "contact" },
];

export const BRAND = {
  symbol: "/brand/montaire-symbol.webp",
  wordmark: "/brand/montaire-wordmark.webp",
  full: "/brand/montaire-full.webp",
};

export const HERO = {
  headline: ["GLOBAL PERSPECTIVE.", "DISCIPLINED GROWTH."],
  paragraphs: [
    "Montaire Group builds, operates, and supports businesses across technology, consumer brands, retail operations, and future ventures.",
    "We combine entrepreneurial thinking with disciplined execution and a long-term perspective to create businesses built for sustainable growth.",
  ],
  supportingLine: "GLOBAL PERSPECTIVE • DISCIPLINED EXECUTION • LONG-TERM VALUE",
};

export const ABOUT = {
  eyebrow: "ABOUT MONTAIRE GROUP",
  headline: ["ONE GROUP.", "MULTIPLE BUSINESSES.", "ONE STANDARD."],
  paragraphs: [
    "Montaire Group Limited is a Hong Kong-based international business group focused on building businesses, strengthening operations, supporting expansion, and creating long-term value.",
    "We combine operational expertise, technology, brand development, and entrepreneurial thinking to support businesses across different industries and markets.",
  ],
  pillars: [
    { title: "HONG KONG BASED", detail: "International headquarters" },
    { title: "GLOBAL OUTLOOK", detail: "Opportunities beyond borders" },
    { title: "LONG-TERM THINKING", detail: "Built for lasting value" },
  ],
};

export const BUSINESSES = {
  eyebrow: "OUR BUSINESSES",
  headline: ["A DIVERSIFIED PLATFORM", "FOR WHAT'S NEXT."],
  items: [
    {
      index: "01",
      name: "RAFESWORKS.COM",
      category: "Technology & Business Operations",
      description:
        "Technology, systems, CRM, POS, HR, finance, operations and business-management tools.",
      cta: "Explore Rafesworks",
      href: "https://rafesworks.com",
      external: true,
      testId: "rafesworks",
    },
    {
      index: "02",
      name: "MONTAIRE LAB",
      category: "Consumer Brands & Innovation",
      description:
        "Developing consumer products, wellness concepts and lifestyle brands built around real customer needs.",
      cta: "Explore Montaire Lab",
      target: "contact",
      testId: "montaire-lab",
    },
    {
      index: "03",
      name: "RETAIL OPERATIONS",
      category: "Retail & Business Operations",
      description:
        "Sales performance, operations, customer experience, team development and scalable retail systems.",
      cta: "Learn More",
      target: "contact",
      testId: "retail-operations",
    },
    {
      index: "04",
      name: "FUTURE VENTURES",
      category: "New Opportunities",
      description:
        "Exploring new businesses, strategic opportunities, partnerships and emerging categories.",
      cta: "Discover More",
      target: "contact",
      testId: "future-ventures",
    },
  ],
};

export const OPERATING_MODEL = {
  eyebrow: "HOW WE WORK",
  headline: ["A DISCIPLINED APPROACH", "TO LASTING VALUE."],
  stages: [
    {
      index: "01",
      title: "BUILD",
      detail: "Identify opportunities and turn ideas into real businesses.",
    },
    {
      index: "02",
      title: "OPERATE",
      detail: "Build strong systems, teams and disciplined operations.",
    },
    {
      index: "03",
      title: "SCALE",
      detail: "Expand across markets, categories and opportunities.",
    },
    {
      index: "04",
      title: "STRENGTHEN",
      detail: "Create long-term structure, efficiency and sustainable value.",
    },
  ],
};

export const BRAND_STATEMENT = {
  lines: ["PRECISION.", "STRUCTURE.", "MOMENTUM."],
  supporting: ["Worldwide vision.", "Local execution.", "Long-term value."],
  backdrop:
    "https://images.pexels.com/photos/10647633/pexels-photo-10647633.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const GLOBAL_SECTION = {
  eyebrow: "GLOBAL PERSPECTIVE",
  headline: ["BUILT IN HONG KONG.", "THINKING BEYOND BORDERS."],
  paragraph:
    "From our base in Hong Kong, Montaire Group takes an international approach to building businesses, identifying opportunities, developing partnerships, and supporting long-term growth.",
  markers: [
    { title: "Hong Kong", detail: "Group Headquarters" },
    { title: "Asia Pacific", detail: "Business Activities" },
    { title: "Global", detail: "Opportunities & Partnerships" },
  ],
};

export const FINAL_CTA = {
  headline: "BUILDING WHAT'S NEXT.",
  paragraph:
    "We build businesses with a long-term perspective — combining ideas, people, technology and disciplined execution.",
};

export const CONTACT = {
  eyebrow: "GET IN TOUCH",
  headline: ["LET'S START", "A CONVERSATION."],
  paragraph:
    "Tell us about your business, your opportunity or your enquiry. A member of the Montaire Group team will review every message.",
  company: "MONTAIRE GROUP LIMITED",
  address: [
    "Unit 909, Prosperity Millennia Plaza",
    "663 King's Road, Quarry Bay",
    "Hong Kong",
  ],
};

export const FOOTER = {
  tagline: ["GLOBAL PERSPECTIVE.", "DISCIPLINED GROWTH."],
  company: "MONTAIRE GROUP LIMITED",
  location: "Hong Kong",
  links: NAV_LINKS.filter((link) => link.target !== "home"),
};
